import smoothScrollbar from 'smooth-scrollbar';
window.smoothScrollbar = smoothScrollbar
export default () => {}